/**
 * Project Location Map - Client Wrapper
 * 
 * Client component that dynamically imports the map component.
 * This ensures Leaflet is never loaded during SSR.
 */

'use client';

import dynamic from 'next/dynamic';
import { type MapComponentProps } from '@/components/core/MapComponent';

// Dynamically import the client component with SSR completely disabled
const ProjectLocationMapClient = dynamic(
  () => import('./ProjectLocationMapClient').then(mod => ({ 
    default: mod.ProjectLocationMapClient 
  })),
  { 
    ssr: false,
    loading: () => (
      <div className="w-full bg-gray-100 rounded-2xl flex items-center justify-center" style={{ height: '500px' }}>
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#BBA339] mb-4"></div>
          <p className="text-gray-600 font-medium">Loading map...</p>
        </div>
      </div>
    )
  }
);

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ProjectLocationMapProps extends Omit<MapComponentProps, 'onGetDirections'> {
  // onGetDirections is handled internally by the client component
}

/**
 * Server-safe map wrapper for project detail pages
 * Can be used in both server and client components
 */
export function ProjectLocationMap(props: ProjectLocationMapProps) {
  return <ProjectLocationMapClient {...props} />;
}

export default ProjectLocationMap;

